module.exports = __webpack_public_path__ + "static/404-image-eb0de6f4ed86de6db806dd813231aae7.svg";